import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);
  const {
    t
  } = useLanguage();
  const faqs = t('faq.items');
  return <section className="w-full py-16 px-6 md:px-12 bg-[var(--color-bg)]" data-id="element-87">
      <div className="max-w-7xl mx-auto" data-id="element-88">
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-89">
          {/* Left side */}
          <div className="lg:w-2/5" data-id="element-90">
            {/* FAQ pill */}
            <div className="inline-block px-4 py-1.5 border border-gray-300 rounded-full mb-6 bg-white" data-id="element-91">
              <span className="text-sm font-medium text-[var(--color-text-dark)]" data-id="element-92">
                {t('faq.pill')}
              </span>
            </div>

            <h2 className="text-3xl font-bold text-[var(--color-text-dark)] mb-4" data-id="element-93">
              {t('faq.title')}
            </h2>
            <p className="text-[var(--color-text-light)] text-sm mb-6" data-id="element-94">
              {t('faq.desc')}
            </p>

            {/* Mobile: FAQ first, then contacts */}
            <div className="lg:hidden mb-8" data-id="element-95">
              <div className="bg-white rounded-2xl p-6 border border-gray-200" data-id="element-96">
                <div className="space-y-0" data-id="element-97">
                  {faqs.map((faq: any) => <div key={faq.id} className="border-b border-gray-100 last:border-0" data-id="element-98">
                      <button onClick={() => setOpenId(openId === faq.id ? null : faq.id)} className="w-full py-4 flex items-start justify-between text-left gap-4" aria-expanded={openId === faq.id} data-id="element-99">
                        <div className="flex gap-3 flex-1" data-id="element-100">
                          <span className="text-[var(--color-text-light)] font-medium text-sm flex-shrink-0" data-id="element-101">
                            {faq.id}
                          </span>
                          <h3 className="text-sm font-medium text-[var(--color-text-dark)]" data-id="element-102">
                            {faq.q}
                          </h3>
                        </div>
                        <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openId === faq.id ? 'bg-[var(--color-tan)]' : 'bg-gray-100'}`} data-id="element-103">
                          <svg className={`w-3.5 h-3.5 transition-colors ${openId === faq.id ? 'text-white' : 'text-gray-500'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-104">
                            {openId === faq.id ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" data-id="element-105" /> : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" data-id="element-106" />}
                          </svg>
                        </div>
                      </button>
                      {/* Content stays in DOM for SEO - hidden via CSS */}
                      <div className={`overflow-hidden transition-all duration-200 ${openId === faq.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-107">
                        <p className="pl-8 pb-4 text-sm text-[var(--color-text-light)]" data-id="element-108">
                          {faq.a}
                        </p>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>

            {/* Contact Buttons - Smaller, Icon Left + Text Right, Centered */}
            <div className="space-y-2" data-id="element-109">
              {/* Telegram */}
              <a href="https://t.me/elvora" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-4 py-2.5 bg-white rounded-lg border border-gray-200 hover:border-gray-300 transition-colors" data-id="element-110">
                <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" fill="none" data-id="element-111">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z" fill="#0088cc" data-id="element-112" />
                </svg>
                <span className="text-sm font-medium text-[var(--color-text-dark)]" data-id="element-113">
                  Telegram
                </span>
              </a>

              {/* Viber */}
              <a href="viber://chat?number=+380" className="flex items-center gap-3 px-4 py-2.5 bg-white rounded-lg border border-gray-200 hover:border-gray-300 transition-colors" data-id="element-114">
                <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" fill="none" data-id="element-115">
                  <circle cx="12" cy="12" r="10" fill="#7360f2" data-id="element-116" />
                  <path d="M12.5 5.5c3.5 0 6.5 2.8 6.5 6.3 0 .4-.3.7-.7.7s-.7-.3-.7-.7c0-2.7-2.2-4.9-5-4.9-.4 0-.7-.3-.7-.7s.3-.7.6-.7zm0 2.8c1.9 0 3.5 1.5 3.5 3.4 0 .4-.3.7-.7.7s-.7-.3-.7-.7c0-1.2-1-2.1-2.1-2.1-.4 0-.7-.3-.7-.7s.3-.6.7-.6zm.7 2.8c.4 0 .7.3.7.7v2.8l.9-.9c.3-.3.7-.3 1 0s.3.7 0 1l-2.1 2.1c-.3.3-.7.3-1 0l-2.1-2.1c-.3-.3-.3-.7 0-1s.7-.3 1 0l.9.9v-2.8c0-.4.3-.7.7-.7z" fill="white" data-id="element-117" />
                </svg>
                <span className="text-sm font-medium text-[var(--color-text-dark)]" data-id="element-118">
                  Viber
                </span>
              </a>

              {/* WhatsApp */}
              <a href="https://wa.me/380" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-4 py-2.5 bg-white rounded-lg border border-gray-200 hover:border-gray-300 transition-colors" data-id="element-119">
                <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" fill="none" data-id="element-120">
                  <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0012.04 2z" fill="#25D366" data-id="element-121" />
                  <path d="M8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.87.86-.87 2.07 0 1.22.89 2.39 1 2.56.14.17 1.76 2.67 4.25 3.73.59.27 1.05.42 1.41.53.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.07-.1-.23-.16-.48-.27-.25-.14-1.47-.74-1.69-.82-.23-.08-.37-.12-.56.12-.16.25-.64.81-.78.97-.15.17-.29.19-.53.07-.26-.13-1.06-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.12-.24-.01-.39.11-.5.11-.11.27-.29.37-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14 0-.3-.01-.47-.01z" fill="white" data-id="element-122" />
                </svg>
                <span className="text-sm font-medium text-[var(--color-text-dark)]" data-id="element-123">
                  WhatsApp
                </span>
              </a>

              {/* Email */}
              <a href="mailto:info@elvora.com" className="flex items-center gap-3 px-4 py-2.5 bg-white rounded-lg border border-gray-200 hover:border-gray-300 transition-colors" data-id="element-124">
                <svg className="w-5 h-5 flex-shrink-0 text-[var(--color-tan)]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-125">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-126" />
                </svg>
                <span className="text-sm font-medium text-[var(--color-text-dark)]" data-id="element-127">
                  Email
                </span>
              </a>
            </div>
          </div>

          {/* Right side - FAQ accordion (Desktop only) */}
          <div className="hidden lg:block lg:w-3/5" data-id="element-128">
            <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200" data-id="element-129">
              <div className="space-y-0" data-id="element-130">
                {faqs.map((faq: any) => <div key={faq.id} className="border-b border-gray-100 last:border-0" data-id="element-131">
                    <button onClick={() => setOpenId(openId === faq.id ? null : faq.id)} className="w-full py-5 flex items-start justify-between text-left gap-4" aria-expanded={openId === faq.id} data-id="element-132">
                      <div className="flex gap-4 flex-1" data-id="element-133">
                        <span className="text-[var(--color-text-light)] font-medium text-sm flex-shrink-0" data-id="element-134">
                          {faq.id}
                        </span>
                        <h3 className="text-base font-medium text-[var(--color-text-dark)]" data-id="element-135">
                          {faq.q}
                        </h3>
                      </div>
                      <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openId === faq.id ? 'bg-[var(--color-tan)]' : 'bg-gray-100'}`} data-id="element-136">
                        <svg className={`w-4 h-4 transition-colors ${openId === faq.id ? 'text-white' : 'text-gray-500'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-137">
                          {openId === faq.id ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" data-id="element-138" /> : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" data-id="element-139" />}
                        </svg>
                      </div>
                    </button>
                    {/* Content stays in DOM for SEO - hidden via CSS */}
                    <div className={`overflow-hidden transition-all duration-200 ${openId === faq.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-140">
                      <p className="pl-10 pb-5 text-sm text-[var(--color-text-light)]" data-id="element-141">
                        {faq.a}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}